import { createAuthedApi } from './authedApi'
import type { CustomerSession } from '../types'

/**
 * Customer/storefront realm: API client + in-memory session (D-053). The access token lives
 * ~15 minutes; a 401 mid-session triggers a silent refresh + retry via the rotating httpOnly
 * `customer_refresh` cookie. See createAuthedApi for the full session model.
 */
export const {
  api,
  getSession,
  setSession,
  clearSession,
  hasSessionHint,
  setUnauthorizedHandler,
  bootstrapSession,
  logoutServerSession,
} = createAuthedApi<CustomerSession>({
  hintKey: 'dukaano.customer.session',
  legacyKey: 'dukaano.customer',
  refreshPath: '/api/storefront/account/refresh',
  logoutPath: '/api/storefront/account/logout',
})
